export const initBlockData = {
  title: "Title page",
  subTitle: "Sub title page",
  blockBackgroundImage: "",
  blockBackgroundImageMobile: "",
};

export const initEmptyBlockData = {
  title: "",
  subTitle: "",
  blockBackgroundImage: "",
  blockBackgroundImageMobile: "",
};
